import { createAction } from '../types/utils';
export var ActionTypes;
(function (ActionTypes) {
    ActionTypes["SEARCH_REQUEST"] = "search::request";
    ActionTypes["SEARCH_FETCH_STARTED"] = "search::fetch_started";
    ActionTypes["SEARCH_SUCCESS"] = "search::success";
    ActionTypes["SEARCH_FAIL"] = "search::fail";
    ActionTypes["SEARCH_CANCEL"] = "search::cancel";
    ActionTypes["SEARCH_RESULT_CLICK"] = "search::result_click";
    ActionTypes["SEARCH_INPUT_CHANGED"] = "search::input_changed";
    ActionTypes["SEARCH_INPUT_FOCUSSED"] = "search::input_focus";
    ActionTypes["SEARCH_INPUT_BLURRED"] = "search::input_blurred";
    ActionTypes["SEARCH_RESET"] = "search::reset";
})(ActionTypes || (ActionTypes = {}));
export const Actions = {
    searchRequest: (payload) => createAction(ActionTypes.SEARCH_REQUEST, payload),
    searchFetchStarted: (payload) => createAction(ActionTypes.SEARCH_FETCH_STARTED, payload),
    searchSuccess: (data) => createAction(ActionTypes.SEARCH_SUCCESS, data),
    searchFail: () => createAction(ActionTypes.SEARCH_FAIL),
    searchCancel: () => createAction(ActionTypes.SEARCH_CANCEL),
    searchResultClick: (articleId, title, index) => createAction(ActionTypes.SEARCH_RESULT_CLICK, { articleId, title, index }),
    // Search Input
    searchTermChanged: (searchTerm) => createAction(ActionTypes.SEARCH_INPUT_CHANGED, { searchTerm }),
    // Search dropdown
    searchInputFocussed: () => createAction(ActionTypes.SEARCH_INPUT_FOCUSSED),
    searchInputBlurred: () => createAction(ActionTypes.SEARCH_INPUT_BLURRED),
    searchReset: () => createAction(ActionTypes.SEARCH_RESET),
};
//# sourceMappingURL=search.js.map